import React from 'react'
import './altcard.scss';
const AltCard = ({ heading, image, content }) => {
    return (
        <div className="alt-card-common">
            {/* Heading Section */}
            <div className="heading">
                <h3>{heading}</h3>
            </div>

            {/* Media Section */}
            {image && (
                <div className="media">
                    <img src={image} alt="Card Visual" />
                </div>
            )}

            {/* Content Section */}
            <div className="Content">
                <div className="Text">
                    <p>
                        <a href={content.mainLink.url} target="_self">
                            {content.mainLink.text}
                        </a>
                    </p>
                    <p>{content.description}</p>
                </div>

                {/* Links Section */}
                <ul>
                    {content.links.map((link, index) => (
                        <li key={index} className="LinkGrouping">
                            <a className="link blueArrowLink" href={link.url}>
                                <span>{link.text}</span>
                            </a>
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    )
}

export default AltCard